
export namespace SaskCurriculum {
    export class Load {
        static readonly type = '[SaskCurriculum] Load';
    }
}